/* eslint-disable multiline-ternary */
import React, { useEffect, useState } from "react";
// ** Cutome Component
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Col,
  Row,
  Form,
  FormFeedback,
} from "reactstrap";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch } from "react-redux";
import { getDiscountCouponList } from "../../../redux/discountCoupon/discountCoupon.thunk";
import { Check } from "react-feather";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import { useForm, Controller } from "react-hook-form";
import "@styles/react/libs/flatpickr/flatpickr.scss";
import ToastContent from "../../components/toast/toast";
import toast from "react-hot-toast";
import {
  CreateDiscountCoupon,
  EditDiscountCoupon,
} from "../../../services/discountCouponService";
import { getErrorMsg } from "../../../common/ErrorMessages/errorMessage";
import ReactDatePicker from "react-datepicker";

const AddDiscountModel = ({
  formModal,
  setFormModal,
  setCurrentPage,
  EditformModal,
  setEditFormModal,
}) => {
  // const [startPicker, setStartPicker] = useState(new Date());
  // const [endPicker, setEndPicker] = useState(new Date());
  // const [isChecked, setIsChecked] = useState(false);
  // const [isGroupChecked, setIsGroupChecked] = useState(false);

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const defaultValues = {
    promotioncode: "",
    couponamount: "",
    startDate: new Date(),
    endDate: new Date(),
  };

  const ValidationData = yup.object({
    promotioncode: yup
      .string()
      .required("Promotion code is Required")
      .max(15, "Promotion code should be not greater than 15 character")
      .matches(/^([a-zA-Z0-9_-]){3,15}$/, "Invalid Promotion Code")
      .trim()
      .typeError("Promotion code is Required"),
    couponamount: yup
      .string()
      .required("Percentage is Required")
      .trim()
      .typeError("Percentage is Required"),
  });

  // ** Hooks

  const {
    setValue,
    reset,
    setError,
    control,
    handleSubmit,
    watch,
    formState: { errors, isDirty },
  } = useForm({ defaultValues, resolver: yupResolver(ValidationData) });

  const onSubmit = (data) => {
    // if (Object.values(data).every((field) => field.length > 0)) {
    setIsLoading(true);
    if (!EditformModal) {
      const val = {
        promotion_code: data.promotioncode,
        percentage: data.couponamount,
        // start_date: moment(startPicker).format("YYYY-MM-DD"),
        // end_date: moment(endPicker).format("YYYY-MM-DD"),
        start_date: moment(data.startDate).format("YYYY-MM-DD"),
        end_date: moment(data.endDate).format("YYYY-MM-DD"),
        one_time_use: data.oneTimeUse ? "1" : "0",
        new_user: data.newUserUse ? "1" : "0",
      };
      CreateDiscountCoupon(val)
        .then((res) => {
          dispatch(getDiscountCouponList(1));
          setCurrentPage(0);
          reset();
          setFormModal(!formModal);
          toast((t) => (
            <ToastContent
              t={t.id}
              message={res?.message}
              icon={<Check size={12} />}
            />
          ));
          reset();
          setFormModal(!formModal);
        })
        .catch((err) => {
          console.log("err: ", err);
          // toast((t) => (
          //   <ToastContent
          //     t={t.id}
          //     message={err.response?.data?.message}
          //     color="danger"
          //     icon={<X size={12} />}
          //   />
          // ));
          getErrorMsg(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      const val = {
        id: EditformModal.id,
        promotion_code: data.promotioncode,
        percentage: data.couponamount,
        // start_date: moment(startPicker).format("YYYY-MM-DD"),
        // end_date: moment(endPicker).format("YYYY-MM-DD"),
        start_date: moment(data.startDate).format("YYYY-MM-DD"),
        end_date: moment(data.endDate).format("YYYY-MM-DD"),
        one_time_use: data.oneTimeUse ? "1" : "0",
        new_user: data.newUserUse ? "1" : "0",
      };
      EditDiscountCoupon(val)
        .then((res) => {
          dispatch(getDiscountCouponList(1));
          setCurrentPage(0);
          reset();
          setFormModal(!formModal);
          toast((t) => (
            <ToastContent
              t={t.id}
              message={res?.message}
              icon={<Check size={12} />}
            />
          ));
          reset();
          setFormModal(!formModal);
          setEditFormModal("");
        })
        .catch((err) => {
          getErrorMsg(err);
          setEditFormModal("");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
    // } else {
    //   for (const key in data) {
    //     if (data[key].length === 0) {
    //       setError(key, {
    //         type: "manual",
    //       });
    //     }
    //   }
    // }
  };

  useEffect(() => {
    if (EditformModal) {
      // const start = new Date(EditformModal.start_date);
      // setStartPicker(start);
      // const endDate = new Date(EditformModal.end_date);
      // setEndPicker(endDate);
      // setIsChecked(EditformModal.one_time_use === "1" ? true : null);
      // setIsGroupChecked(EditformModal?.new_user === "1" ? true : null);
      reset({
        promotioncode: EditformModal.promotion_code,
        couponamount: EditformModal.percentage,
        startDate: new Date(EditformModal.start_date),
        endDate: new Date(EditformModal.end_date),
        oneTimeUse: EditformModal.one_time_use === "1" ? true : null,
        newUserUse: EditformModal?.new_user === "1" ? true : null,
      });
    }
  }, []);

  const ResetForm = () => {
    setFormModal(!formModal);
    setEditFormModal("");
    reset();
  };

  // const handleCheckboxChange = (e) => {
  //   setIsChecked(e.target.checked);
  // };

  // const handleGroupCheckboxChange = (e) => {
  //   setIsGroupChecked(e.target.checked);
  // };

  return (
    <>
      <Modal
        isOpen={formModal}
        toggle={ResetForm}
        className="modal-dialog-centered modal-lg"
        // onClosed={() => setCardType("")}
      >
        <ModalHeader
          className="bg-transparent"
          toggle={() => {
            setFormModal(!formModal);
            setEditFormModal("");
          }}
        ></ModalHeader>
        <ModalBody className="px-sm-5 mx-50 pb-5">
          <h1 className="text-center mb-1">
            {EditformModal ? "Edit Discount Coupon" : "Add Discount Coupon"}
          </h1>
          {/* <p className="text-center">Add card for future billing</p> */}
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              {/* Project Name */}
              <Col xs="12" md="6">
                <div className="mb-1">
                  <Label className="form-label" for="promotioncode">
                    Promotion Code
                  </Label>
                  <Controller
                    id="promotioncode"
                    name="promotioncode"
                    defaultValue=""
                    control={control}
                    render={({ field }) => (
                      <Input
                        maxLength={15}
                        {...field}
                        type="text"
                        placeholder="Promotion Code"
                        // invalid={errors.promotioncode && true}
                      />
                    )}
                  />
                  {errors.promotioncode && (
                    <FormFeedback>{errors.promotioncode.message}</FormFeedback>
                  )}
                </div>
              </Col>
              <Col xs="12" md="6">
                <div className="mb-1">
                  <Label className="form-label" for="couponamount">
                    Coupon Percentage
                  </Label>
                  <Controller
                    id="couponamount"
                    name="couponamount"
                    control={control}
                    render={({ field }) => (
                      <Input
                        maxLength={3}
                        {...field}
                        onChange={(e) => {
                          const pattern = /^(?:[1-9][0-9]*)?$/;
                          if (pattern.test(e.target.value)) {
                            if (e.target.value <= 100) {
                              setValue("couponamount", e.target.value);
                              setError("couponamount", "");
                            }
                          }
                        }}
                        type="text"
                        // invalid={errors.couponamount && true}
                        placeholder="Coupon Percentage"
                      />
                    )}
                  />
                  {errors.couponamount && (
                    <FormFeedback>{errors.couponamount.message}</FormFeedback>
                  )}
                </div>
              </Col>
              <Col xs="12" md="6">
                <div className="mb-1">
                  <Label className="form-label" for="firstName">
                    Promotion Start Date
                  </Label>

                  {/* <ReactDatePicker
                    id="startDate"
                    placeholderText="Select Start Date"
                    selected={startPicker}
                    onChange={(date) => setStartPicker(date)}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    className="form-control"
                    dateFormat="MM/dd/yy"
                    minDate={moment().toDate()}
                    calendarClassName="custom-datepicker-calendar"
                    popperClassName="custom-datepicker-popper"
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                  /> */}

                  <Controller
                    name="startDate"
                    control={control}
                    render={({ field }) => (
                      <ReactDatePicker
                        {...field}
                        placeholderText="Select Start Date"
                        selected={field.value}
                        onChange={(date) => {
                          field.onChange();
                          setValue("startDate", date);
                        }}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control"
                        dateFormat="MM/dd/yy"
                        minDate={moment().toDate()}
                        calendarClassName="custom-datepicker-calendar"
                        popperClassName="custom-datepicker-popper"
                        onKeyDown={(e) => {
                          e.preventDefault();
                        }}
                      />
                    )}
                  />
                </div>
              </Col>
              <Col xs="12" md="6">
                <div className="mb-1">
                  <Label className="form-label" for="firstName">
                    Promotion End Date
                  </Label>

                  {/* <ReactDatePicker
                    id="startDate"
                    name="endDate"
                    placeholderText="Select End Date"
                    selected={endPicker}
                    onChange={(date) => setEndPicker(date)}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    className="form-control"
                    dateFormat="MM/dd/yy"
                    minDate={startPicker}
                    calendarClassName="custom-datepicker-calendar"
                    popperClassName="custom-datepicker-popper"
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                  /> */}

                  <Controller
                    name="endDate"
                    control={control}
                    render={({ field }) => (
                      <ReactDatePicker
                        {...field}
                        id="endDate"
                        placeholderText="Select End Date"
                        selected={field.value}
                        onChange={(date) => {
                          field.onChange();
                          setValue("endDate", date);
                        }}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control"
                        dateFormat="MM/dd/yy"
                        minDate={watch("startDate")} // You may want to adjust this based on your specific requirements
                        calendarClassName="custom-datepicker-calendar"
                        popperClassName="custom-datepicker-popper"
                        onKeyDown={(e) => {
                          e.preventDefault();
                        }}
                      />
                    )}
                  />
                  {/* {errors.endPicker && (
                    <FormFeedback>{errors.endPicker.message}</FormFeedback>
                  )} */}
                </div>
              </Col>
              <Col xs="12" md="6">
                <div className="mb-1">
                  {/* <Input
                    id="checkbox"
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    disabled={EditformModal}
                    className="me-50"
                  /> */}

                  <Controller
                    name="oneTimeUse"
                    control={control}
                    defaultValue={false} // Set the default value for the checkbox
                    render={({ field }) => (
                      <Input
                        id="oneTimeUse"
                        type="checkbox"
                        checked={field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                        disabled={EditformModal} // Assuming EditformModal is a variable in your component
                        className="me-50"
                      />
                    )}
                  />
                  <Label className="form-label me-1" for="oneTimeUse">
                    Allow the user to use this coupon only once.
                  </Label>
                </div>
              </Col>
              <Col xs="12">
                <div className="mb-1">
                  {/* <Input
                    id="group"
                    type="checkbox"
                    checked={isGroupChecked}
                    onChange={handleGroupCheckboxChange}
                    disabled={EditformModal}
                    className="me-50"
                  /> */}

                  <Controller
                    name="newUserUse"
                    control={control}
                    defaultValue={false} // Set the default value for the checkbox
                    render={({ field }) => (
                      <Input
                        id="newUserUse"
                        type="checkbox"
                        checked={field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                        disabled={EditformModal} // Assuming EditformModal is a variable in your component
                        className="me-50"
                      />
                    )}
                  />
                  <Label className="form-label me-1" for="newUserUse">
                    Allow only new user to use this coupon.
                  </Label>
                </div>
              </Col>
              {/* <Col xs="12" md="12">
                <div className="mb-1">
                  <Label className="form-label" for="expirydiscount">
                    Expiry of Discount in Months
                  </Label>
                  <Controller
                    id="expirydiscount"
                    name="expirydiscount"
                    defaultValue=""
                    control={control}
                    render={({ field }) => (
                      <Input
                        {...field}
                        placeholder=""
                        invalid={errors.expirydiscount && true}
                      />
                    )}
                  />
                  {errors.expirydiscount && (
                    <FormFeedback>{errors.expirydiscount.message}</FormFeedback>
                  )}
                </div>
              </Col> */}
              {/* <Col xs="12" md="12">
                <div className="mb-1">
                  <p>
                    <b>Note:</b>This number specifies the number of months the
                    discount will be applicable after purchase of the product.
                    The Discount can't be renewed or doesn't get carried forward
                    to next subscription purchase.
                  </p>
                </div>
              </Col> */}
              <Col xs={12} className="mt-2 pt-50 text-center">
                <Button
                  type="submit"
                  className="me-1 "
                  color="primary"
                  disabled={isLoading || !isDirty}
                >
                  {isLoading
                    ? EditformModal
                      ? "Updating..."
                      : "Creating..."
                    : EditformModal
                    ? "Edit Discount Coupon"
                    : "Create Discount Coupon"}
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AddDiscountModel;
